'use strict';

var urlUtil = require('./../common/urlUtil');

function createQueryParam(params) {
    var query = '';
    delete params.countryCode;
    var keys = Object.keys(params);
    keys.forEach((key, index) => {
        query += `&${key}=${params[key]}`;
    });
    return query;
};

function activeFeFilter () {
    var queryParams = urlUtil.getQueryParams();
    var keys = Object.keys(queryParams);
    $(document).find('.js-filter-event .cc-service-items').removeClass('cc-active-iteams');
    keys.forEach((key, index) => {
        if (queryParams[key] == 'true') {
            $(document).find('.js-filter-event #js-boutique-filter-' + key).addClass('cc-active-iteams');
        }
    });
};

function updateQueryParam() {
    var url = document.location.href;
    // duplicate filter with pickup - they works on same param and the pickup copy provide info about return and pickup
    // var returned = $('#js-boutique-filter-returned').hasClass('cc-active-iteams');
    // url = urlUtil.replaceOrAddQueryParam(url, 'returned', returned);
    var pickup = $('#js-boutique-filter-pickup').hasClass('cc-active-iteams');
    url = urlUtil.replaceOrAddQueryParam(url, 'pickup', pickup);
    var sartoria = $('#js-boutique-filter-sartoria').hasClass('cc-active-iteams');
    url = urlUtil.replaceOrAddQueryParam(url, 'sartoria', sartoria);
    var fragrances = $('#js-boutique-filter-fragrances').hasClass('cc-active-iteams');
    url = urlUtil.replaceOrAddQueryParam(url, 'fragrances', fragrances);
    history.replaceState(null, null, url);
};

function updateboutiques(filterListHtml, displayValue) {
    $('.state-boutiques').html(displayValue);
    $('#boutiques-results').replaceWith(filterListHtml);
};

function cleanFilter() {
    // $('#js-boutique-filter-returned').removeClass('cc-active-iteams').find('button').attr('aria-selected', 'false');
    // $('#js-boutique-filter-repair').removeClass('cc-active-iteams').find('button').attr('aria-selected', 'false');
    $('#js-boutique-filter-sartoria').removeClass('cc-active-iteams').find('button').attr('aria-selected', 'false');
    $('#js-boutique-filter-pickup').removeClass('cc-active-iteams').find('button').attr('aria-selected', 'false');
    $('#js-boutique-filter-fragrances').removeClass('cc-active-iteams').find('button').attr('aria-selected', 'false');
};

module.exports = {
    createQueryParam: createQueryParam,
    activeFeFilter: activeFeFilter,
    updateQueryParam: updateQueryParam,
    updateboutiques: updateboutiques,
    cleanFilter: cleanFilter
};
